import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-layout-grid-line',
      title: 'Tabiques y trasdosados',
      tag: 'Más solicitado',
      description: 'Divisiones interiores y revestimientos de paredes con opciones de aislamiento acústico y térmico. Soluciones directas y autoportantes.',
      image: 'https://public.readdy.ai/ai/img_res/f567d5a334cb80d2db2866ecebcec1a8.jpg',
    },
    {
      icon: 'ri-stack-line',
      title: 'Falsos techos',
      tag: 'Especialidad',
      description: 'Techos continuos y registrables para ocultar instalaciones, mejorar aislamiento y crear ambientes modernos. Acabados lisos y perfectos.',
      image: 'https://readdy.ai/api/search-image?query=suspended%20white%20ceiling%20with%20smooth%20plasterboard%20finish%20modern%20interior%20lighting&width=600&height=400&seq=service-02&orientation=landscape',
    },
    {
      icon: 'ri-sound-module-line',
      title: 'Aislamientos acústicos y térmicos',
      tag: 'Confort',
      description: 'Soluciones con lana mineral y placas especiales para reducir ruido y mejorar eficiencia energética. Ideal para viviendas y oficinas.',
      image: 'https://readdy.ai/api/search-image?query=mineral%20wool%20insulation%20installation%20between%20drywall%20panels%20construction%20work&width=600&height=400&seq=service-03&orientation=landscape',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 },
    },
  };

  return (
    <section id="servicios" className="py-16 sm:py-24 bg-bg-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-12 sm:mb-16 gap-6">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-gray-500 text-base sm:text-lg font-light mb-2"
            >
              Nuestros servicios
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="text-primary-dark text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-serif leading-tight"
            >
              Soluciones profesionales<br />de pladur en Barcelona
            </motion.h2>
          </div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-text-dark text-sm sm:text-base leading-relaxed max-w-xl"
          >
            Ofrecemos servicios completos de <strong>instalación de pladur en Barcelona</strong> para viviendas, oficinas y locales comerciales. Trabajamos en toda la ciudad y área metropolitana con garantía de calidad.
          </motion.p>
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6"
        >
          {services.map((service, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ y: -8, transition: { duration: 0.3 } }}
              className="bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 overflow-hidden group cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6 sm:p-8">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4 sm:mb-6 group-hover:rotate-12 transition-transform duration-300">
                  <i className={`${service.icon} text-primary text-2xl sm:text-3xl`}></i>
                </div>
                <h3 className="text-primary-dark text-xl sm:text-2xl font-bold mb-3 leading-tight break-words">
                  {service.title}
                </h3>
                <span className="inline-block bg-[#D4FF00] text-primary-dark text-xs font-bold px-3 py-1 rounded-full mb-4">
                  {service.tag}
                </span>
                <p className="text-gray-600 text-sm sm:text-[15px] leading-relaxed mb-6">
                  {service.description}
                </p>
                <Link
                  to="/servicios"
                  className="text-primary font-semibold text-sm sm:text-base flex items-center space-x-2 hover:underline group/link"
                >
                  <span>Más información</span>
                  <i className="ri-arrow-right-line group-hover/link:translate-x-1 transition-transform"></i>
                </Link>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-8 sm:mt-12"
        >
          <Link
            to="/servicios"
            className="inline-flex items-center space-x-2 bg-primary text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold text-sm sm:text-base hover:bg-primary-dark transition-all duration-300 hover:shadow-lg whitespace-nowrap"
          >
            <span>Ver todos los servicios</span>
            <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesSection;
